/**
 * Get folder name for edit mode based on unique pending images folders
 */
export const getEditFolderName = (uniquePendingImagesFolders: (string | undefined)[]) => {
  const validFolders = uniquePendingImagesFolders.filter((folder) => Boolean(folder));

  return validFolders.length > 0
    ? validFolders.length === 1
      ? validFolders[0]
      : `${validFolders.length} folders`
    : null;
};

/**
 * Get folder name for upload mode based on unique pending images folders and current folder
 */
export const getUploadFolderName = (
  uniquePendingImagesFolders: (string | undefined)[],
  currentFolder?: string,
) => {
  return uniquePendingImagesFolders.length > 0
    ? uniquePendingImagesFolders.length === 1
      ? uniquePendingImagesFolders[0] || currentFolder
      : `${uniquePendingImagesFolders.length} folders`
    : currentFolder;
};
